(function() {
  'use strict';

  // Store selected sizes per product
  const selectedSizes = {};
  
  // Track which products have size selected (for faster lookup)
  const productSizeSelected = {};

  function shouldBypassSizeValidation(productInfo) {
    const type = (productInfo?.dataset?.productType || '').toLowerCase();
    return type === 'rings' || type === 'ring' || type === 'bracelets' || type === 'bracelet';
  }

  function storeSizeSelection(productId, sizeValue) {
    selectedSizes[productId] = sizeValue;
    productSizeSelected[productId] = true; // Mark as selected
    //console.log('[Size Validator] Stored size:', sizeValue, 'for product:', productId);
  }

  function restoreSizeSelection(productInfo) {
    const productId = productInfo.dataset.productId || productInfo.querySelector('[data-product-form]')?.id;
    
    if (!productId || !selectedSizes[productId]) return;

    // Look for Size fieldset specifically
    let sizeFieldset = productInfo.querySelector('fieldset[data-option-name="Size"]');
    if (!sizeFieldset) {
      const sldWraps = productInfo.querySelectorAll('.sld-wrap');
      sldWraps.forEach(wrap => {
        const optionName = wrap.getAttribute('data-option-name');
        if (optionName && optionName.includes('Size')) {
          sizeFieldset = wrap;
        }
      });
    }
    
    if (!sizeFieldset) return;

    const sizeInputs = sizeFieldset.querySelectorAll('input[type="radio"]');
    const storedSize = selectedSizes[productId];

    sizeInputs.forEach(input => {
      if (input.value === storedSize) {
        input.checked = true;
       // console.log('[Size Validator] Restored size:', storedSize);
        
        // Update the displayed value
        const legend = sizeFieldset.querySelector('[data-selected-value]');
        if (legend) {
          legend.textContent = storedSize;
        }
        
        // Update flag
        productSizeSelected[productId] = true;
        
       // console.log('[Size Validator] Size restored, variant ID can now be set');
      }
    });
  }

  function validateSizeSelection(productInfo) {
    if (shouldBypassSizeValidation(productInfo)) {
      return true;
    }

    // Check if product has SIZE options specifically (not Alphabet)
    let sizeFieldset = productInfo.querySelector('fieldset[data-option-name="Size"]');
    
    // Fallback: look for .sld-wrap that is for Size
    if (!sizeFieldset) {
      const sldWraps = productInfo.querySelectorAll('.sld-wrap');
      sldWraps.forEach(wrap => {
        const optionName = wrap.getAttribute('data-option-name');
        if (optionName && optionName.includes('Size')) {
          sizeFieldset = wrap;
        }
      });
    }
    
    if (!sizeFieldset) {
      // No size option, allow normal add to cart
     // console.log('[Size Validator] No SIZE fieldset found, allowing add to cart');
      return true;
    }
    
    //console.log('[Size Validator] Found SIZE fieldset:', sizeFieldset.dataset.optionName);

    // Check if a size is selected
    const sizeInputs = sizeFieldset.querySelectorAll('input[type="radio"]');
    const checkedInputs = Array.from(sizeInputs).filter(input => input.checked);
    const isSizeSelected = checkedInputs.length > 0;
    
    console.log('[Size Validator] Validation check:', {
      totalSizeOptions: sizeInputs.length,
      checkedOptions: checkedInputs.length,
      checkedValues: checkedInputs.map(i => i.value),
      isSizeSelected: isSizeSelected
    });

    if (!isSizeSelected) {
      // Show error message - it's the next sibling of the fieldset
      let errorMessage = sizeFieldset.nextElementSibling;
      //console.log('[Size Validator] Looking for error message. Next sibling:', errorMessage);
      
      if (errorMessage && errorMessage.classList.contains('size-selection-error')) {
        errorMessage.style.display = 'block';
       // console.log('[Size Validator] ✅ SHOWING ERROR MESSAGE:', errorMessage.textContent);
      } else {
        console.warn('[Size Validator] ⚠️ Error message not found! Next sibling classes:', 
                     errorMessage ? errorMessage.className : 'no sibling');
      }

      // Scroll to size options
      sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Add shake animation to fieldset
      sizeFieldset.style.animation = 'shake 0.5s';
      setTimeout(() => {
        sizeFieldset.style.animation = '';
      }, 500);

      //console.log('[Size Validator] ❌ Please select a size before adding to cart');
      
      return false;
    } else {
      // Hide error message if size is selected
      let errorMessage = sizeFieldset.nextElementSibling;
      if (errorMessage && errorMessage.classList.contains('size-selection-error')) {
        errorMessage.style.display = 'none';
        //console.log('[Size Validator] ✅ HIDING ERROR MESSAGE');
      }
      return true;
    }
  }

  function initSizeValidator() {
    // Get all product-form elements
    const productFormElements = document.querySelectorAll('product-form');
    
    productFormElements.forEach(productFormEl => {
      const productInfo = productFormEl.closest('product-info');
      if (!productInfo) return;

      const productId = productInfo.dataset.productId || productFormEl.dataset.sectionId;
      const form = productFormEl.querySelector('form');
      const bypassSizeValidation = shouldBypassSizeValidation(productInfo);
      
      if (!form) return;
      
      // Get the variant ID input
      const variantIdInput = form.querySelector('input[name="id"]') || form.querySelector('.product-variant-id');
      
      // Check if this product has size option
      const hasSizeOption = variantIdInput && variantIdInput.dataset.hasSizeOption === 'true';

      // On initial page load, ensure no size is selected
      // Look for Size fieldset specifically (not Alphabet)
      let sizeFieldset = productInfo.querySelector('fieldset[data-option-name="Size"]');
      if (!sizeFieldset) {
        // Fallback: look for .sld-wrap that is for Size only
        const sldWraps = productInfo.querySelectorAll('.sld-wrap');
        sldWraps.forEach(wrap => {
          const optionName = wrap.getAttribute('data-option-name');
          if (optionName && optionName.includes('Size')) {
            sizeFieldset = wrap;
          }
        });
      }
      
      if (sizeFieldset && !bypassSizeValidation) {
       // console.log('[Size Validator] Found SIZE fieldset on page load:', sizeFieldset.dataset.optionName);
        
        const sizeInputs = sizeFieldset.querySelectorAll('input[type="radio"]');
       // console.log('[Size Validator] Found', sizeInputs.length, 'size options');
        
        let hadCheckedSize = false;
        
        // Only uncheck on initial page load, not on subsequent renders
        // Mark the fieldset so we don't uncheck again
        if (!sizeFieldset.hasAttribute('data-size-initialized') && sizeInputs > 1 ) {
          sizeInputs.forEach(input => {
            if (input.checked) {
              console.log('[Size Validator] Unchecking pre-selected size on INITIAL page load:', input.value);
              input.checked = false;
              hadCheckedSize = true;
            }
          });
          
          sizeFieldset.setAttribute('data-size-initialized', 'true');
        } else {
          //console.log('[Size Validator] Size already initialized, skipping uncheck');
        }
        
        // Clear the displayed selected value text ONLY for Size
        const selectedValueDisplay = sizeFieldset.querySelector('[data-selected-value]');
        if (selectedValueDisplay) {
          const oldValue = selectedValueDisplay.textContent.trim();
          if (oldValue) {
            selectedValueDisplay.textContent = '';
            //console.log('[Size Validator] Cleared SIZE selected value display (was:', oldValue, ')');
          }
        } else {
          //console.warn('[Size Validator] data-selected-value element not found');
        }
        
        // Always clear the variant ID on page load (but don't disable it - that causes "Unavailable" button)
        if (variantIdInput && sizeInputs > 1) {
          const initialValue = variantIdInput.value;
          if (initialValue) {
           // console.log('[Size Validator] Clearing variant ID on page load:', initialValue);
            variantIdInput.value = '';
            variantIdInput.setAttribute('data-cleared-on-load', 'true');
          } else {
            //console.log('[Size Validator] Variant ID already empty');
          }
        } else {
         // console.warn('[Size Validator] Variant ID input not found');
        }
        
        // Clear the size selected flag on page load
        productSizeSelected[productId] = false;
        
        //console.log('[Size Validator] ✓ Page load complete - size must be selected before checkout');
        
        // Add click handler to the main add to cart button
        const addToCartButton = form.querySelector('[data-add-to-cart]');
        if (addToCartButton && hasSizeOption) {
          addToCartButton.addEventListener('click', function(e) {
            //console.log('[Size Validator] Add to cart button clicked');
            
            // Check if variant ID is empty
            const currentVariantId = variantIdInput ? variantIdInput.value : '';
            //console.log('[Size Validator] Button click - Variant ID:', currentVariantId || '(empty)');
            
            if (!currentVariantId || currentVariantId === '') {
            //  console.log('[Size Validator] ❌ Button click - VARIANT ID EMPTY, blocking and showing error');
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              
              // Validate to show error message
              validateSizeSelection(productInfo);
              return false;
            }
            
            // Find the CURRENT size fieldset (don't use cached reference)
            let currentSizeFieldset = productInfo.querySelector('fieldset[data-option-name="Size"]');
            if (!currentSizeFieldset) {
              const sldWraps = productInfo.querySelectorAll('.sld-wrap');
              sldWraps.forEach(wrap => {
                const optionName = wrap.getAttribute('data-option-name');
                if (optionName && optionName.includes('Size')) {
                  currentSizeFieldset = wrap;
                }
              });
            }
            
            // Check if size is selected
            if (currentSizeFieldset) {
              const sizeInputs = currentSizeFieldset.querySelectorAll('input[type="radio"]');
              const isSizeSelected = Array.from(sizeInputs).some(input => input.checked);
              
              console.log('[Size Validator] Button click - Size check:', {
                fieldsetFound: !!currentSizeFieldset,
                totalInputs: sizeInputs.length,
                isSizeSelected: isSizeSelected
              });
              
              if (!isSizeSelected) {
                //console.log('[Size Validator] ❌ Button click - SIZE NOT SELECTED, blocking and showing error');
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                // Show error message
                validateSizeSelection(productInfo);
                return false;
              }
            }
            
            //console.log('[Size Validator] ✓ Button click validation passed');
          }, true); // Capture phase
          
          //console.log('[Size Validator] ✓ Button click handler attached');
        }
        
        // Protect variant ID input from being changed by theme until size is selected
        if (hasSizeOption && variantIdInput && !bypassSizeValidation) {
          // Override the value setter to prevent programmatic changes
          const originalValueDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
          const customValueDescriptor = {
            get: originalValueDescriptor.get,
            set: function(newValue) {
              // Check if this is the variant ID input we're protecting
              if (this === variantIdInput) {
                // Check flag first (faster), then fall back to DOM check
                let isSizeSelected = productSizeSelected[productId] || false;
                
                // If flag says not selected, double-check the DOM with CURRENT fieldset
                if (!isSizeSelected) {
                  // Query for current fieldset (don't use cached reference)
                  let currentSizeFieldset = productInfo.querySelector('fieldset[data-option-name="Size"]');
                  if (!currentSizeFieldset) {
                    const sldWraps = productInfo.querySelectorAll('.sld-wrap');
                    sldWraps.forEach(wrap => {
                      const optionName = wrap.getAttribute('data-option-name');
                      if (optionName && optionName.includes('Size')) {
                        currentSizeFieldset = wrap;
                      }
                    });
                  }
                  
                  if (currentSizeFieldset) {
                    const currentSizeInputs = currentSizeFieldset.querySelectorAll('input[type="radio"]');
                    isSizeSelected = Array.from(currentSizeInputs).some(input => input.checked);
                    if (isSizeSelected) {
                      productSizeSelected[productId] = true; // Update flag
                    }
                  }
                }
                
                //console.log('[Size Validator] Setter called. Value:', newValue || '(empty)', 'Size selected:', isSizeSelected);
                
                // Only allow setting variant ID if size is selected OR if clearing it
                if (newValue && newValue !== '' && !isSizeSelected) {
                 // console.log('[Size Validator] ⚠️ BLOCKED variant ID setter - no size selected. Attempted value:', newValue);
                  return; // Don't set the value
                }
                
                //console.log('[Size Validator] ✅ Allowing variant ID change:', newValue || '(empty)');
              }
              
              // Call original setter
              originalValueDescriptor.set.call(this, newValue);
            }
          };
          
          Object.defineProperty(variantIdInput, 'value', customValueDescriptor);
          
         // console.log('[Size Validator] ✓ Variant ID protection active (setter override)');
        }
      } else {
       // console.log('[Size Validator] No size fieldset found - product may not have sizes');
      }

      // Intercept form submit at CAPTURE phase - runs before product-form's handler
      form.addEventListener('submit', function(e) {
       // console.log('[Size Validator] ========================================');
        //console.log('[Size Validator] Form submit intercepted (capture phase)');
        //console.log('[Size Validator] Event type:', e.type);
        //console.log('[Size Validator] Event isTrusted:', e.isTrusted);
        
        // Check if product has size option
        if (hasSizeOption && !bypassSizeValidation) {
          // Check if variant ID is empty
          const currentVariantId = variantIdInput ? variantIdInput.value : '';
          //console.log('[Size Validator] Current variant ID:', currentVariantId || '(empty)');
          
          if (!currentVariantId || currentVariantId === '') {
            //console.log('[Size Validator] ❌ VARIANT ID IS EMPTY - BLOCKING SUBMIT');
            if (!validateSizeSelection(productInfo)) {
              //console.log('[Size Validator] ❌ SIZE NOT SELECTED - SHOWING ERROR');
            }
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
          
          // Also validate size selection
          if (!validateSizeSelection(productInfo)) {
            //console.log('[Size Validator] ❌ VALIDATION FAILED - BLOCKING SUBMIT');
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }
        
       // console.log('[Size Validator] ✓ Validation passed, allowing form to submit');
        //console.log('[Size Validator] ========================================');
        // Don't prevent - let it bubble to product-form's handler
      }, true); // CAPTURE PHASE - runs BEFORE product-form's handler

      // Use event delegation on product-info (which doesn't get re-rendered)
      // This way listeners work even when size inputs are dynamically replaced
      if (!productInfo.hasAttribute('data-size-listener-attached')) {
        productInfo.setAttribute('data-size-listener-attached', 'true');
        
        productInfo.addEventListener('change', function(e) {
          // Check if the changed element is a size radio input
          if (e.target.type === 'radio') {
            // Find the parent fieldset
            const fieldset = e.target.closest('fieldset[data-option-name="Size"], .sld-wrap[data-option-name*="Size"]');
            
            if (fieldset && e.target.checked) {
              //console.log('[Size Validator] Size input changed:', e.target.value);
              
              const currentProductId = productInfo.dataset.productId || 
                                       productInfo.querySelector('product-form')?.dataset.sectionId;
              
              if (currentProductId) {
                storeSizeSelection(currentProductId, e.target.value);
                
                // Update the displayed selected value
                const selectedValueDisplay = fieldset.querySelector('[data-selected-value]');
                if (selectedValueDisplay) {
                  selectedValueDisplay.textContent = e.target.value;
                  //console.log('[Size Validator] Updated selected value display:', e.target.value);
                }
                
                //console.log('[Size Validator] Size selected, variant ID can now be set');
              }
              
              // Hide error message when size is selected
              let errorMessage = fieldset.nextElementSibling;
              if (errorMessage && errorMessage.classList.contains('size-selection-error')) {
                errorMessage.style.display = 'none';
              }
            }
          }
        });
        
       // console.log('[Size Validator] ✓ Attached event delegation listener to product-info');
      }
    });

    // Handle cart-bar button clicks (both add-to-cart and scroll variants)
    document.addEventListener('click', function(e) {
      // Find the cart-bar button (can have either data-cart-bar-add-to-cart or data-cart-bar-scroll)
      const cartBarButton = e.target.closest('[data-cart-bar-add-to-cart], [data-cart-bar-scroll]');
      
      if (!cartBarButton) return; // Not a cart-bar button
      
      //console.log('[Size Validator] Cart-bar button clicked');
      
      const productInfo = document.querySelector('product-info');
      if (!productInfo) {
        //console.warn('[Size Validator] Product-info not found');
        return;
      }
      
      // Check if product has size option
      const productForm = productInfo.querySelector('product-form');
      if (productForm) {
        const form = productForm.querySelector('form');
        if (form) {
          const variantIdInput = form.querySelector('input[name="id"]') || form.querySelector('.product-variant-id');
          const hasSizeOption = variantIdInput && variantIdInput.dataset.hasSizeOption === 'true';
          const bypassSizeValidation = shouldBypassSizeValidation(productInfo);
          
          if (hasSizeOption && !bypassSizeValidation) {
            const currentVariantId = variantIdInput.value;
            //console.log('[Size Validator] Cart-bar - Variant ID:', currentVariantId || '(empty)');
            
            if (!currentVariantId || currentVariantId === '') {
             // console.log('[Size Validator] ❌ Cart-bar - VARIANT ID EMPTY, blocking and showing error');
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              
              // Validate to show error message
              validateSizeSelection(productInfo);
              return false;
            }
          }
        }
      }

      // Validate size
      if (!validateSizeSelection(productInfo)) {
       // console.log('[Size Validator] Cart-bar: validation failed, stopping event');
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }

     // console.log('[Size Validator] Cart-bar: validation passed, clicking main button');
      
      // Stop cart-bar's default behavior
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Find the main add-to-cart button and click it (for AJAX add to cart)
      const mainButton = productInfo.querySelector('[data-add-to-cart]');
      if (mainButton) {
        //console.log('[Size Validator] Clicking main button:', mainButton);
        mainButton.click(); // Real click, not dispatchEvent
      } else {
        //console.warn('[Size Validator] Main button not found');
      }
    }, true); // Capture phase - runs before other handlers

  }

  // Prevent scroll to top when size is selected
  function preventScrollWhenSizeSelected() {
    setTimeout(() => {
      const cartBar = document.querySelector('cart-bar');
      if (!cartBar || typeof cartBar.scrollToTop !== 'function') {
       // console.log('[Size Validator] Cart bar or scrollToTop not found');
        return;
      }
      
      const originalScrollToTop = cartBar.scrollToTop.bind(cartBar);
      
      cartBar.scrollToTop = function() {
          const productInfo = document.querySelector('product-info');
          if (productInfo) {
            if (shouldBypassSizeValidation(productInfo)) {
              originalScrollToTop();
              return;
            }

            // Try multiple selectors for compatibility
            let sizeFieldset = productInfo.querySelector('.sld-wrap');
          if (!sizeFieldset) {
            sizeFieldset = productInfo.querySelector('fieldset[data-option-name*="Size"]');
          }
          
          if (sizeFieldset) {
            const sizeInputs = sizeFieldset.querySelectorAll('input[type="radio"]');
            const isSizeSelected = Array.from(sizeInputs).some(input => input.checked);
            
            if (isSizeSelected) {
              //console.log('[Size Validator] Preventing scroll - size is selected');
              return; // Don't scroll
            }
          }
        }
        
        //console.log('[Size Validator] Allowing scroll - no size or not selected');
        originalScrollToTop();
      };
      
      //console.log('[Size Validator] Successfully wrapped scrollToTop');
    }, 1000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSizeValidator();
      preventScrollWhenSizeSelected();
    });
  } else {
    initSizeValidator();
    preventScrollWhenSizeSelected();
  }

  // Re-initialize and restore size after variant changes
  if (typeof subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
    subscribe(theme.PUB_SUB_EVENTS.variantChange, function(data) {
      //console.log('[Size Validator] Variant changed, checking size selection');
      
      // Use a longer delay to ensure DOM is fully updated
      setTimeout(() => {
        const productInfo = document.querySelector('product-info');
        if (productInfo) {
          if (shouldBypassSizeValidation(productInfo)) {
            return;
          }

          const productFormEl = productInfo.querySelector('product-form');
          const productId = productInfo.dataset.productId || (productFormEl ? productFormEl.dataset.sectionId : null);
          
          // Check if we have a stored size for this product
          const hasStoredSize = productId && selectedSizes[productId];
          
         // console.log('[Size Validator] Checking stored size:', hasStoredSize ? selectedSizes[productId] : 'none');
          
          // No need to re-attach event listeners - we're using event delegation!
          
          if (hasStoredSize) {
            // User has selected a size previously - restore it
            //console.log('[Size Validator] Restoring previously selected size');
            restoreSizeSelection(productInfo);
          } else {
            // No size stored - check if one is currently selected
            let sizeFieldset = productInfo.querySelector('fieldset[data-option-name="Size"]');
            if (!sizeFieldset) {
              const sldWraps = productInfo.querySelectorAll('.sld-wrap');
              sldWraps.forEach(wrap => {
                const optionName = wrap.getAttribute('data-option-name');
                if (optionName && optionName.includes('Size')) {
                  sizeFieldset = wrap;
                }
              });
            }
            
            if (sizeFieldset) {
              const sizeInputs = sizeFieldset.querySelectorAll('input[type="radio"]');
              const isSizeSelected = Array.from(sizeInputs).some(input => input.checked);
              
              if (!isSizeSelected) {
                // No size selected - clear the variant ID to prevent form submission
                if (productFormEl) {
                  const form = productFormEl.querySelector('form');
                  if (form) {
                    const variantIdInput = form.querySelector('input[name="id"]') || form.querySelector('.product-variant-id');
                    if (variantIdInput && variantIdInput.value) {
                     // console.log('[Size Validator] Variant changed but no size selected - clearing variant ID');
                      variantIdInput.value = '';
                    }
                    
                    // Clear the flag
                    if (productId) {
                      productSizeSelected[productId] = false;
                    }
                  }
                }
              }
            }
          }
        }
      }, 150); // Increased delay to ensure DOM is ready
    });
  }
})();
